import { FC } from 'react';

import PageWithSidebar from 'components/PageWithSidebar';
import Skeleton from '@mui/material/Skeleton';
import SidebarSkeleton from 'components/SidebarSkeleton';
import TabberSkeleton from 'components/TabberSkeleton';
import FormSkeleton from 'components/FormSkeleton';

import { Path } from 'components/Breadcrumbs';

type Props = {
  sidebarBoxes?: number;
  tabs?: number;
  breadcrumbs?: Path[];
};

const EntityEditPageSkeleton: FC<Props> = props => {
  const { breadcrumbs = [], sidebarBoxes, tabs, children } = props;

  return (
    <PageWithSidebar
      sidebar={<SidebarSkeleton boxes={sidebarBoxes} />}
      breadcrumbs={[...breadcrumbs, { name: <Skeleton width={100} /> }]}>
      {children ?? (
        <>
          <TabberSkeleton tabs={tabs} />
          <FormSkeleton />
        </>
      )}
    </PageWithSidebar>
  );
};

export default EntityEditPageSkeleton;
